/* Kreator zestawów Neosyntis. Dane produktów, presety i parametry rabatu
   przychodzą z sekcji jako window.KZ, więc ten plik nie zna katalogu. */
(function(){

  "use strict";
  var CDN = "";  // pełne adresy zdjęć przychodzą z Liquid

  /* Katalog: nazwy, ceny i pliki zdjęć wzięte z żywego sklepu 21.09.2026.
     Ceny w groszach, żeby nie liczyć rabatu na floatach. */
  var PRODUKTY = (window.KZ && KZ.produkty) || [];

  /* Presety. Jednorodne z rozmysłem: celowe tylko z suplementów, badawcze
     tylko z fiolek. Mieszać wolno klientowi, my tego nie proponujemy. */
  var PRESETY = (window.KZ && KZ.presety) || [];

  var GROSZ = 1;            // cena trzeciego produktu w promocji 2+1
  var MAKS_SZT = ((window.KZ && KZ.rabat && KZ.rabat.maksSztuk) || 8);
  /* Ile sztuk musi byc w zestawie, zeby dalo sie go zamowic. Decyzja Radka
     z 21.09: ponizej trzech to nie jest zestaw, tylko pojedynczy produkt,
     a ten kupuje sie z karty produktu. Liczba siedzi w ustawieniach sekcji. */
  var MIN_ZESTAW = ((window.KZ && KZ.rabat && KZ.rabat.minZestaw) || 3);

  /* produkt / produkty / produktow: polska odmiana po liczbie. */
  function ileSlowo(n){
    var d=n%10, s=n%100;
    if(n===1) return "produkt";
    if(d>=2 && d<=4 && (s<12 || s>14)) return "produkty";
    return "produktów";
  }
  var stan = {};            // handle -> ilość
  var aktywnyPreset = null;
  var filtr = "wszystko";   // wszystko | nss | ruo
  var odkryte = {};         // co już wjechało na scroll, żeby nie wjeżdżało drugi raz
  var swiezy = null;        // handle produktu dodanego przed chwilą
  var poprzednieNetto = null, poprzedniStopien = null;

  /* Etykiety czytane raz, z tego co wyrenderowal Liquid. Wczesniej JS wpisywal
     „Zamawiam” na sztywno i kasowal to, co wlasciciel ustawil w panelu. */
  var ETY_CTA = (document.getElementById("cta").textContent || "Zamawiam").trim();
  var ETY_BELKA = (document.getElementById("belkaCta").textContent || ETY_CTA).trim();
  var ETY_PUSTO = "Wybierz produkty";

  /* Dwa dymki, bo przyciski sa dwa: w panelu (komputer i otwarta szuflada)
     oraz w belce na dole telefonu. Tresc zawsze ta sama, ustawiana w jednym
     miejscu, zeby nie dalo sie ich rozjechac. */
  var DYMKI = [document.getElementById("dymekPanel"), document.getElementById("dymekBelka")];

  function tekstDymka(ile){
    if(ile>=MIN_ZESTAW) return "";
    if(ile===0){
      return "Zestaw to minimum <strong>"+MIN_ZESTAW+" "+ileSlowo(MIN_ZESTAW)+"</strong>. Najtańszy z nich kosztuje 1 grosz.";
    }
    var brak=MIN_ZESTAW-ile;
    return "Jeszcze <strong>"+brak+" "+ileSlowo(brak)+"</strong> i zamawiasz. Zestaw to minimum "+
           MIN_ZESTAW+" "+ileSlowo(MIN_ZESTAW)+", najtańszy kosztuje 1 grosz.";
  }
  function ustawDymek(html){
    DYMKI.forEach(function(d){
      if(!d) return;
      if(!html){ d.hidden=true; return; }
      if(d.innerHTML!==html) d.innerHTML=html;
      d.hidden=false;
    });
  }
  function pulsDymka(){
    DYMKI.forEach(function(d){
      if(!d || d.hidden) return;
      d.classList.remove("is-puls"); void d.offsetWidth; d.classList.add("is-puls");
    });
  }

  var pln = new Intl.NumberFormat("pl-PL",{style:"currency",currency:"PLN"});
  function zl(gr){ return pln.format(gr/100); }
  function prod(h){ for(var i=0;i<PRODUKTY.length;i++){ if(PRODUKTY[i].h===h) return PRODUKTY[i]; } return null; }
  function sztuk(){ var s=0; for(var h in stan){ s+=stan[h]; } return s; }

  /* ---------------------------------------------------------------
     Rdzeń: policz oba warianty i oddaj korzystniejszy.
     Wariant 2+1 działa tak jak funkcja na sklepie: na każde pełne trzy
     sztuki najtańsza sztuka w koszyku kosztuje 1 grosz.
     --------------------------------------------------------------- */
  /* Zasada z 21.09 (Radek): grosz zostaje ZAWSZE, a od czwartej sztuki dochodzi
     procent na produkty płatne i rośnie z każdą kolejną sztuką.
     4 szt = 3 płatne −10 % + 1 za grosz, 5 szt = −15 %, i tak dalej, do sufitu. */
  function ustawienia(){
    var r=(window.KZ && KZ.rabat) || {};
    return { od:r.od||4, start:r.start||10, krok:r.krok||5, maks:r.maks||30 };
  }
  function procentDla(n){
    var u=ustawienia();
    if(n<u.od) return 0;
    return Math.min(u.maks, u.start + (n-u.od)*u.krok);
  }

  function policz(zrodloStanu){
    var s = zrodloStanu || stan;
    var jednostki=[];
    for(var h in s){ for(var i=0;i<s[h];i++){ jednostki.push({h:h,c:prod(h).c}); } }
    jednostki.sort(function(a,b){ return a.c-b.c; });

    var brutto=0, i2;
    for(i2=0;i2<jednostki.length;i2++){ brutto+=jednostki[i2].c; }

    // Jeden produkt za grosz: zawsze najtańszy w koszyku, zawsze tylko jeden.
    var grosz = jednostki.length>=3 ? 1 : 0;
    var rabatGrosz = grosz ? (jednostki[0].c - GROSZ) : 0;
    var groszowe={};
    if(grosz){ groszowe[jednostki[0].h]=1; }

    // Procent liczy się od produktów PŁATNYCH, czyli bez tego za grosz.
    var platne=0;
    for(i2=grosz;i2<jednostki.length;i2++){ platne+=jednostki[i2].c; }
    var pct = procentDla(jednostki.length);
    var rabatPct = Math.round(platne*pct/100);

    var rabat = rabatGrosz + rabatPct;
    return {
      sztuk:jednostki.length, brutto:brutto, platne:platne,
      rabat:rabat, rabatGrosz:rabatGrosz, rabatPct:rabatPct,
      pct:pct, zestawy:grosz, groszowe:groszowe,
      zrodlo: jednostki.length===0 ? "" : (pct ? "obie" : "2plus1"),
      netto: brutto - rabat
    };
  }

  /* --------------------------- widok --------------------------- */
  function rysujPresety(){
    var box=document.getElementById("presety"), html="";
    PRESETY.forEach(function(p){
      /* Cena kafla liczy się tą samą funkcją co koszyk, więc kafel nigdy nie
         obieca innej kwoty niż ta, którą klient zobaczy po kliknięciu. */
      var probny={};
      p.sklad.forEach(function(h){ probny[h]=(probny[h]||0)+1; });
      var w=policz(probny);
      /* Krótka nazwa: bez przedrostka NSS- i bez ™, bo w tym kafelku liczy się,
         CO jest w zestawie, a nie jak brzmi pełna nazwa handlowa. */
      var sklad=p.sklad.map(function(h){
        return prod(h).n.replace(/^NSS-/,"").replace(/™/g,"");
      }).join(" <em>+</em> ");
      html += '<button class="preset'+(aktywnyPreset===p.id?" is-active":"")+'" type="button" data-preset="'+p.id+'">'+
              '<span class="preset__cel">'+p.cel+'</span>'+
              '<span class="preset__nazwa">'+p.nazwa+'</span>'+
              '<span class="preset__sklad">'+sklad+'</span>'+
              '<span class="preset__cena">'+p.sklad.length+' produkty · <strong>'+zl(w.netto)+'</strong></span>'+
              '</button>';
    });
    html += '<button class="preset preset--wlasny" type="button" data-preset="wlasny">'+
            '<span class="preset__cel">Własny mix</span>'+
            '<span class="preset__nazwa">Zbuduj sam</span>'+
            '<span class="preset__sklad"><em>Wybierasz sam, do ośmiu produktów</em></span>'+
            '<span class="preset__cena">Wybierz z 18 produktów</span>'+
            '</button>';
    box.innerHTML=html;
  }

  function kartaHtml(p,idx){
    var ile=stan[p.h]||0;
    var mod = p.g==="ruo" ? " karta--ruo" : "";
    /* Raz odkryta karta zostaje odkryta. Bez tego każde dodanie produktu
       przerysowuje siatkę i wszystko wjeżdżałoby od nowa. */
    if(odkryte[p.h]) mod += " in-view";
    if(swiezy===p.h) mod += " is-swiezy";
    var pelny = sztuk()>=MAKS_SZT;
    var akcja = ile>0
      ? '<div class="stepper"><button type="button" data-minus="'+p.h+'" aria-label="Mniej">&minus;</button>'+
        '<span class="stepper__val">'+ile+'</span>'+
        '<button type="button" data-plus="'+p.h+'" aria-label="Więcej"'+(pelny?' disabled':'')+'>+</button></div>'
      : '<button class="btn-dodaj" type="button" data-plus="'+p.h+'" aria-label="Dodaj '+p.n+' do zestawu"'+(pelny?' disabled':'')+'>Dodaj</button>';
    return '<article class="karta reveal'+mod+(ile>0?" is-wybrany":"")+'" data-h="'+p.h+'" style="--i:'+((idx||0)%6)+'">'+
      '<div class="karta__media"><img src="'+CDN+p.img+'" alt="'+p.n+'" loading="lazy"></div>'+
      '<h3 class="karta__nazwa">'+p.n+'</h3>'+
      '<p class="karta__opis">'+p.o+'</p>'+
      '<p class="karta__cena">'+zl(p.c)+'</p>'+
      '<div class="karta__akcja">'+akcja+'</div></article>';
  }

  /* Jedna siatka na obie linie. Wcześniej stały w osobnych sekcjach i czytało
     się to jak dwa sklepy obok siebie, a koszyk i tak jest wspólny. Teraz jest
     jedna półka: suplementy z przodu, odczynniki dalej, ta sama forma kafelka,
     a różnicę niesie czerwona plakietka RUO, cena i zdanie pod nagłówkiem.
     Chipy nie przewijają już do sekcji, tylko zawężają widok. */
  function rysujKatalog(){
    var lista=PRODUKTY.filter(function(p){
      return filtr==="wszystko" ? true : p.g===filtr;
    });
    var ileNss=lista.filter(function(p){ return p.g==="nss"; }).length;
    var ileRuo=lista.length-ileNss;
    var podpis = ileNss && ileRuo
      ? '<strong>Suplementy NSS</strong> to kapsułki do spożycia, <strong>odczynniki</strong> to liofilizowane peptydy klasy RUO wyłącznie do badań laboratoryjnych, nie do spożycia. Rabat liczy się od wszystkiego, co wrzucisz do zestawu.'
      : (ileRuo
          ? '<strong>Liofilizowane peptydy klasy RUO.</strong> Wyłącznie do badań laboratoryjnych, nie do spożycia.'
          : 'Suplementy diety w kapsułkach, jeden składnik aktywny w odmierzonej dawce.');

    document.getElementById("katalog").innerHTML =
      '<section class="grupa"><div class="grupa__head reveal'+(odkryte.naglowek?" in-view":"")+'" data-h="naglowek">'+
        '<h2 class="grupa__title">'+(filtr==="nss"?"Suplementy NSS":filtr==="ruo"?"Odczynniki do badań":"Wszystkie produkty")+'</h2>'+
        '<span class="grupa__count">'+lista.length+' do wyboru</span>'+
        '<p class="grupa__note">'+podpis+'</p>'+
      '</div><div class="siatka">'+lista.map(function(p,i){ return kartaHtml(p,i); }).join("")+'</div></section>';
  }

  function najtanszyWKoszyku(){
    var best=null;
    for(var h in stan){ if(!best || prod(h).c<prod(best).c) best=h; }
    return best;
  }

  function podpowiedzTekst(w){
    if(w.sztuk===0) return "Wybierz trzy produkty. <strong>Trzeci kosztuje 1 grosz.</strong>";
    if(w.sztuk<3){
      var brak=3-w.sztuk;
      return "Brakuje <strong>"+brak+"</strong> "+(brak===1?"produktu":"produktów")+" do trzeciego za 1 grosz.";
    }
    if(w.sztuk>=MAKS_SZT){
      return "Zestaw pełny: <strong>"+MAKS_SZT+" produktów</strong>, najtańszy za 1 grosz i <strong>"+w.pct+"%</strong> na pozostałe. Większego zestawu nie składamy.";
    }
    var kolejny=procentDla(w.sztuk+1);
    if(w.pct===0){
      return "Najtańszy produkt za <strong>1 grosz</strong>. Dołóż czwarty, a pozostałe stanieją o <strong>"+kolejny+"%</strong>.";
    }
    return "Najtańszy za <strong>1 grosz</strong> plus <strong>"+w.pct+"%</strong> na pozostałe."+
           (kolejny>w.pct ? " Przy "+(w.sztuk+1)+" sztukach będzie "+kolejny+"%." : " To nasz największy rabat.");
  }

  function rysujPanel(){
    var w=policz();
    var docelowo = w.sztuk>3 ? MAKS_SZT : 3;
    var polka=document.getElementById("polka");
    polka.className = "polka" + (docelowo>3 ? " polka--max" : "");

    var jednostki=[];
    for(var h in stan){ for(var i=0;i<stan[h];i++){ jednostki.push(h); } }
    jednostki.sort(function(a,b){ return prod(a).c-prod(b).c; });

    var html="";
    for(var s=0;s<Math.max(docelowo,jednostki.length);s++){
      if(s<jednostki.length){
        var p=prod(jednostki[s]);
        var jestGrosz = s < w.zestawy;
        var nowy = swiezy===jednostki[s] ? " is-nowy" : "";
        html += '<div class="slot is-pelny'+nowy+'"><img src="'+CDN+p.img+'" alt="'+p.n+'">'+
                '<button type="button" class="slot__x" data-minus="'+jednostki[s]+'" aria-label="Usuń '+p.n+' z zestawu">&times;</button>'+
                (jestGrosz?'<span class="slot__grosz">1 grosz</span>':'')+'</div>';

      } else {
        html += '<div class="slot"><span class="slot__nr">'+(s+1)+'</span></div>';
      }
    }
    polka.innerHTML=html;

    /* Pasek: najpierw droga do trzeciego produktu za grosz, potem do sufitu rabatu. */
    var maks=ustawienia().maks;
    var postep = w.sztuk<3 ? (w.sztuk/3*30) : (30 + 70*((w.sztuk-3)/(MAKS_SZT-3)));
    document.getElementById("pasekFill").style.width = Math.min(100,Math.round(postep))+"%";
    document.getElementById("podpowiedz").innerHTML = podpowiedzTekst(w);

    /* Jednorazowy błysk paska, gdy zmienia się to, co dostaje klient. */
    var pasek=document.querySelector(".pasek");
    var stopien = w.sztuk>=3 ? ("g"+w.pct) : "";
    if(poprzedniStopien!==null && stopien!==poprzedniStopien && stopien!==""){
      pasek.classList.remove("is-prog"); void pasek.offsetWidth; pasek.classList.add("is-prog");
    }
    poprzedniStopien=stopien;

    // lista pozycji
    var li="";
    Object.keys(stan).forEach(function(h){
      var p=prod(h), ile=stan[h], gr=w.groszowe[h]||0;
      var meta = gr>0
        ? '<s>'+zl(p.c*ile)+'</s> <span class="poz__grosz">'+(gr===ile?"za 1 grosz":gr+" szt. za 1 grosz")+'</span>'
        : zl(p.c*ile);
      li += '<li class="poz"><span class="poz__img"><img src="'+CDN+p.img+'" alt=""></span>'+
            '<span><p class="poz__nazwa">'+p.n+'</p><span class="poz__meta">'+meta+'</span></span>'+
            '<span class="mini"><button type="button" data-minus="'+h+'" aria-label="Mniej">&minus;</button>'+
            '<span>'+ile+'</span>'+
            '<button type="button" data-plus="'+h+'" aria-label="Więcej"'+(w.sztuk>=MAKS_SZT?' disabled':'')+'>+</button></span>'+
            '<button type="button" class="poz__x" data-usun="'+h+'" aria-label="Usuń '+p.n+' z zestawu">&times;</button></li>';
    });
    document.getElementById("lista").innerHTML=li;

    document.getElementById("etykietaPrzed").textContent = "Przed rabatem" + (w.sztuk? " ("+w.sztuk+" szt.)" : "");
    document.getElementById("sumaPrzed").textContent = zl(w.brutto);
    var wiersze="";
    if(w.rabatGrosz) wiersze+='<div class="sumy__row sumy__row--rabat"><span>Najtańszy za 1 grosz</span><span>-'+zl(w.rabatGrosz)+'</span></div>';
    if(w.rabatPct)   wiersze+='<div class="sumy__row sumy__row--rabat"><span>Rabat '+w.pct+'% na pozostałe</span><span>-'+zl(w.rabatPct)+'</span></div>';
    if(!wiersze)     wiersze='<div class="sumy__row sumy__row--rabat"><span>Rabat</span><span>0,00 zł</span></div>';
    document.getElementById("rabaty").innerHTML=wiersze;
    document.getElementById("sumaPo").textContent = zl(w.netto);
    var wiersz=document.querySelector(".sumy__row--razem");
    if(poprzednieNetto!==null && poprzednieNetto!==w.netto){
      wiersz.classList.remove("is-zmiana"); void wiersz.offsetWidth; wiersz.classList.add("is-zmiana");
    }
    poprzednieNetto=w.netto;
    document.getElementById("zrodlo").textContent =
      w.sztuk===0 ? "" :
      w.pct ? "2+1 za 1 grosz i "+w.pct+"% na pozostałe produkty." :
      w.sztuk>=3 ? "Promocja 2+1 za 1 grosz." : "";

    /* Zamawianie odblokowuje sie dopiero od MIN_ZESTAW sztuk, w obu miejscach
       naraz: w panelu na komputerze i w belce na telefonie. Belka mowi wprost,
       ile brakuje — „0,00 zl” obok czerwonego przycisku samo prosilo sie
       o dotkniecie, a potem otwierala sie pusta szuflada. */
    var pusty = w.sztuk===0;
    var brakDo = MIN_ZESTAW - w.sztuk;
    var zablokowane = w.sztuk < MIN_ZESTAW;

    var cta=document.getElementById("cta");
    cta.disabled = zablokowane;
    cta.textContent = pusty ? ETY_PUSTO : (zablokowane ? "Dobierz jeszcze "+brakDo+" "+ileSlowo(brakDo) : ETY_CTA);

    var belka=document.getElementById("belka");
    var belkaCta=document.getElementById("belkaCta");
    belka.classList.toggle("is-blokada", zablokowane);
    belka.classList.toggle("is-pusta", pusty);
    /* W belce etykieta musi byc krotka: przy „Dobierz jeszcze 2 produkty” kwota
       obok nie miescila sie juz na waskim telefonie. Cale zdanie niesie dymek. */
    belkaCta.textContent = pusty ? ETY_PUSTO : (zablokowane ? "Dobierz "+brakDo : ETY_BELKA);
    belkaCta.setAttribute("aria-disabled", zablokowane ? "true" : "false");
    document.getElementById("belkaKwota").textContent = pusty ? "Zestaw pusty" : zl(w.netto);
    document.getElementById("belkaPod").textContent =
      pusty ? "Dodaj "+MIN_ZESTAW+" "+ileSlowo(MIN_ZESTAW)+", najtańszy kosztuje 1 grosz" :
      zablokowane ? "Jeszcze "+brakDo+" "+ileSlowo(brakDo)+" do pełnego zestawu" :
      w.sztuk+" szt. · oszczędzasz "+zl(w.rabat)+" · dotknij, by zobaczyć zestaw";

    /* Dymek wisi nad przyciskiem tak dlugo, jak dlugo zestaw jest niepelny. */
    ustawDymek(tekstDymka(w.sztuk));
  }

  /* ---------------------------- ruch ----------------------------
     Wejścia na scroll działają tak jak w motywie: obserwator dokłada
     `in-view` przy 12 % widoczności, a resztę robi CSS. Karty pamiętają,
     że już wjechały, bo siatka przerysowuje się przy każdym kliknięciu. */
  var obsRev=null;
  function ozywReveal(){
    if(!("IntersectionObserver" in window)){
      document.querySelectorAll(".reveal,.reveal-h").forEach(function(el){ el.classList.add("in-view"); });
      return;
    }
    if(obsRev) obsRev.disconnect();
    obsRev=new IntersectionObserver(function(wpisy){
      wpisy.forEach(function(w){
        if(!w.isIntersecting) return;
        w.target.classList.add("in-view");
        var h=w.target.getAttribute("data-h");
        if(h) odkryte[h]=true;
        obsRev.unobserve(w.target);
      });
    },{threshold:.12});
    document.querySelectorAll(".reveal:not(.in-view),.reveal-h:not(.in-view)").forEach(function(el){ obsRev.observe(el); });
  }

  /* Klon zdjęcia leci z kafelka na półkę zestawu (na telefonie do belki),
     żeby było widać, DOKĄD produkt trafił. Klon jest `position: fixed`,
     więc nie rusza układu strony i znika po locie. */
  function lecDoZestawu(img){
    if(!img || !img.animate) return;
    var mobil=window.matchMedia("(max-width:1040px)").matches;
    var celEl=document.getElementById(mobil?"belka":"polka");
    if(!celEl) return;
    var s=img.getBoundingClientRect(), c=celEl.getBoundingClientRect();
    if(!s.width || !c.width) return;
    var klon=document.createElement("img");
    klon.src=img.currentSrc||img.src;
    klon.className="lot";
    klon.style.left=s.left+"px"; klon.style.top=s.top+"px";
    klon.style.width=s.width+"px"; klon.style.height=s.height+"px";
    document.body.appendChild(klon);
    var dx=(c.left+c.width/2)-(s.left+s.width/2);
    var dy=(c.top+Math.min(c.height/2,56))-(s.top+s.height/2);
    var skala=Math.max(.3,Math.min(.6,86/s.height));
    var anim=klon.animate([
      {transform:"translate(0,0) scale(1) rotate(0deg)",opacity:1,
       filter:"drop-shadow(0 12px 22px rgba(0,0,0,.7))",offset:0},
      {transform:"translate("+(dx*.42)+"px,"+(dy*.28-52)+"px) scale("+(skala*1.42)+") rotate(-5deg)",opacity:1,
       filter:"drop-shadow(0 0 30px rgba(225,29,42,.95)) brightness(1.25) saturate(1.5)",offset:.42},
      {transform:"translate("+(dx*.86)+"px,"+(dy*.82)+"px) scale("+(skala*1.06)+") rotate(-1deg)",opacity:.85,
       filter:"drop-shadow(0 0 20px rgba(225,29,42,.7))",offset:.8},
      {transform:"translate("+dx+"px,"+dy+"px) scale("+(skala*.92)+") rotate(0deg)",opacity:0,
       filter:"drop-shadow(0 0 10px rgba(225,29,42,.35))",offset:1}
    ],{duration:900,easing:"cubic-bezier(.33,0,.15,1)"});
    anim.onfinish=function(){ klon.remove(); };
    anim.oncancel=function(){ klon.remove(); };
    /* Siatka bezpieczeństwa: w karcie schowanej w tle przeglądarka wstrzymuje
       animacje, `onfinish` nigdy nie przychodzi i klon zostałby na stronie. */
    setTimeout(function(){ if(klon.parentNode) klon.remove(); }, 1500);
  }

  /* Zestaw pełny: zamiast cicho nie reagować, panel mruga i mówi dlaczego. */
  function pokazLimit(){
    var p=document.getElementById("podpowiedz");
    p.innerHTML='Zestaw pełny. <strong>'+MAKS_SZT+' produktów to maksimum</strong> w jednym zestawie.';
    p.classList.remove("is-limit"); void p.offsetWidth; p.classList.add("is-limit");
    var pa=document.querySelector(".pasek");
    pa.classList.remove("is-prog"); void pa.offsetWidth; pa.classList.add("is-prog");
  }

  /* Jedno żądanie do koszyka, potem prosto do kasy. Bez strony koszyka. */
  var wysylka=false;
  function zamow(){
    if(wysylka) return;
    var pozycje=[];
    for(var h in stan){ pozycje.push({ id: prod(h).wariant, quantity: stan[h] }); }
    /* Druga bramka, na wypadek gdyby ktos dotknal przycisku szybciej niz
       przerysuje sie panel: ponizej minimum nie wychodzimy do kasy. */
    if(!pozycje.length || sztuk()<MIN_ZESTAW) return;
    wysylka=true;
    var cta=document.getElementById("cta");
    var etykieta=cta.textContent;
    cta.textContent="Przenoszę do kasy...";
    fetch("/cart/add.js",{
      method:"POST",
      headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({items:pozycje})
    }).then(function(r){
      if(!r.ok) throw new Error("koszyk");
      window.location.href="/checkout";
    }).catch(function(){
      wysylka=false;
      cta.textContent=etykieta;
      document.getElementById("podpowiedz").innerHTML="Nie udało się dodać zestawu. Odśwież stronę i spróbuj jeszcze raz.";
    });
  }

  function rysuj(){ rysujPresety(); rysujKatalog(); rysujPanel(); ozywReveal(); swiezy=null; }

  /* --------------------------- zdarzenia --------------------------- */
  document.addEventListener("click", function(e){
    var fil=e.target.closest("[data-filtr]");
    if(fil){
      filtr=fil.getAttribute("data-filtr");
      document.querySelectorAll("[data-filtr]").forEach(function(c){
        c.classList.toggle("is-akt", c===fil);
      });
      rysujKatalog();
      return;
    }
    var usun=e.target.closest("[data-usun]");
    if(usun){
      delete stan[usun.getAttribute("data-usun")];
      aktywnyPreset=null;
      rysuj();
      return;
    }
    var plus=e.target.closest("[data-plus]"), minus=e.target.closest("[data-minus]"), pre=e.target.closest("[data-preset]");
    if(plus){
      var hp=plus.getAttribute("data-plus");
      if(sztuk()>=MAKS_SZT){ pokazLimit(); return; }
      var kartaZrodlo=plus.closest(".karta");
      stan[hp]=(stan[hp]||0)+1;
      aktywnyPreset=null;
      swiezy=hp;
      /* Lot odpalamy PRZED przerysowaniem, póki kafelek źródłowy jeszcze stoi. */
      if(kartaZrodlo) lecDoZestawu(kartaZrodlo.querySelector(".karta__media img"));
      rysuj();
      return;
    }
    if(minus){ var hm=minus.getAttribute("data-minus"); stan[hm]=(stan[hm]||0)-1; if(stan[hm]<=0) delete stan[hm]; aktywnyPreset=null; rysuj(); return; }
    if(pre){
      var id=pre.getAttribute("data-preset");
      stan={};
      /* Po wybraniu gotowego zestawu zdejmujemy filtr, żeby było widać
         wszystko, co wpadło do zestawu, a nie tylko część. */
      filtr="wszystko";
      document.querySelectorAll("[data-filtr]").forEach(function(c){
        c.classList.toggle("is-akt", c.getAttribute("data-filtr")==="wszystko");
      });
      if(id!=="wlasny"){
        var p=PRESETY.filter(function(x){ return x.id===id; })[0];
        p.sklad.forEach(function(h){ stan[h]=(stan[h]||0)+1; });
        aktywnyPreset=id;
      } else { aktywnyPreset=null; }
      rysuj();
      if(window.matchMedia("(max-width:1040px)").matches) otworzPanel(true);
      return;
    }
    if(e.target.id==="cta"){
      zamow();
    }
  });

  /* Dotkniecie „Zamawiam” przy pustym zestawie. Szuflady nie otwieramy, bo nie
     ma w niej czego ogladac, a na telefonie zaslania caly katalog i blokuje
     przewijanie strony. Zamiast tego: belka sie trzesie, strona zjezdza do
     katalogu, a pierwszy przycisk „Dodaj” pulsuje, zeby bylo widac gdzie. */
  var powrotPodpowiedzi=null;
  function nudzDoKatalogu(){
    var belka=document.getElementById("belka");
    belka.classList.remove("is-trzesie"); void belka.offsetWidth; belka.classList.add("is-trzesie");
    pulsDymka();
    var brak=MIN_ZESTAW-sztuk();
    document.getElementById("belkaPod").textContent = sztuk()===0
      ? "Najpierw dodaj produkty do zestawu"
      : "Brakuje "+brak+" "+ileSlowo(brak)+" do zestawu";
    var kat=document.getElementById("katalog");
    if(kat && kat.scrollIntoView) kat.scrollIntoView({behavior:"smooth",block:"start"});
    var pierwszy=document.querySelector("#katalog .btn-dodaj:not([disabled])");
    if(pierwszy){
      pierwszy.classList.remove("is-wskaz"); void pierwszy.offsetWidth; pierwszy.classList.add("is-wskaz");
      setTimeout(function(){ pierwszy.classList.remove("is-wskaz"); }, 2400);
    }
    clearTimeout(powrotPodpowiedzi);
    powrotPodpowiedzi=setTimeout(function(){ if(sztuk()<MIN_ZESTAW) rysujPanel(); }, 2600);
  }

  function otworzPanel(on){
    document.getElementById("panel").classList.toggle("is-otwarty", on);
    document.getElementById("zaslona").classList.toggle("is-widoczna", on);
    document.body.style.overflow = on ? "hidden" : "";
  }
  /* Na telefonie przycisk zamawia od razu, a podgląd zestawu otwiera się
     dotknięciem kwoty obok. Pusty zestaw nie otwiera już niczego, patrz
     `nudzDoKatalogu`: pusta szuflada na cały ekran była ślepą uliczką. */
  /* Szufladę można ściągnąć palcem w dół, jak w aplikacji. Gest łapiemy tylko
     wtedy, gdy lista jest przewinięta na samą górę, żeby nie walczyć
     z przewijaniem treści w środku. */
  (function(){
    var panel=document.getElementById("panel");
    var startY=0, ciagnie=false, przesuniecie=0;
    panel.addEventListener("touchstart", function(e){
      if(!panel.classList.contains("is-otwarty")) return;
      if(panel.scrollTop>0) return;
      startY=e.touches[0].clientY; ciagnie=true; przesuniecie=0;
      panel.style.transition="none";
    }, {passive:true});
    panel.addEventListener("touchmove", function(e){
      if(!ciagnie) return;
      przesuniecie=e.touches[0].clientY-startY;
      if(przesuniecie<0) przesuniecie=0;
      panel.style.transform="translateY("+przesuniecie+"px)";
    }, {passive:true});
    panel.addEventListener("touchend", function(){
      if(!ciagnie) return;
      ciagnie=false;
      panel.style.transition="";
      panel.style.transform="";
      if(przesuniecie>90) otworzPanel(false);
    });
  })();

  document.getElementById("belkaCta").addEventListener("click", function(){
    if(sztuk()<MIN_ZESTAW){ nudzDoKatalogu(); return; }
    document.getElementById("cta").click();
  });
  document.querySelector(".belka__info").addEventListener("click", function(){
    if(sztuk()===0){ nudzDoKatalogu(); return; }
    otworzPanel(true);
  });
  document.getElementById("zamknij").addEventListener("click", function(){ otworzPanel(false); });
  document.getElementById("zaslona").addEventListener("click", function(){ otworzPanel(false); });
  document.addEventListener("keydown", function(e){
    if(e.key!=="Escape") return;
    zamknijSamouczek();
    otworzPanel(false);
  });


  /* --------------------------- samouczek ---------------------------
     Kroki przychodza z sekcji, te same co w HTML nad katalogiem. Okienko
     pokazuje sie raz na przegladarke i tylko na telefonie: na komputerze
     panel zestawu stoi obok katalogu i widac wszystko naraz. Pod naglowkiem
     zostaje przycisk, zeby dalo sie je otworzyc ponownie. */
  var SAM = (window.KZ && KZ.samouczek) || null;
  var KLUCZ_SAM = "kz-samouczek-1";
  var onb = null;

  function widzialSamouczek(){
    try{ return localStorage.getItem(KLUCZ_SAM)==="1"; }
    catch(e){ return false; }   // tryb prywatny: pokazemy, nie zapiszemy
  }
  function zapamietajSamouczek(){
    try{ localStorage.setItem(KLUCZ_SAM,"1"); }catch(e){}
  }

  function budujSamouczek(){
    if(onb || !SAM) return onb;
    var kroki="";
    (SAM.kroki||[]).forEach(function(k,i){
      kroki+='<li class="kz-jak__krok"><span class="kz-jak__nr" aria-hidden="true">'+(i+1)+'</span>'+
             '<p class="kz-jak__nazwa">'+k.t+'</p><p class="kz-jak__opis">'+k.o+'</p></li>';
    });
    onb=document.createElement("div");
    onb.className="kz-onb";
    onb.setAttribute("role","dialog");
    onb.setAttribute("aria-modal","true");
    onb.setAttribute("aria-label", SAM.tytul || "Jak złożyć zestaw");
    onb.innerHTML='<div class="kz-onb__karta">'+
      '<h2 class="kz-onb__tytul">'+(SAM.tytul||"")+'</h2>'+
      '<p class="kz-onb__lead">'+(SAM.lead||"")+'</p>'+
      '<ol class="kz-jak__kroki">'+kroki+'</ol>'+
      '<button type="button" class="kz-onb__start" id="onbStart">'+(SAM.start||"Zaczynam")+'</button>'+
      '</div>';
    /* Zamyka przycisk i tlo. Kto nie chce czytac, wychodzi jednym dotknieciem
       gdziekolwiek obok karty. */
    onb.addEventListener("click", function(e){
      if(e.target===onb || e.target.id==="onbStart") zamknijSamouczek();
    });
    document.body.appendChild(onb);
    return onb;
  }
  function pokazSamouczek(){
    var el=budujSamouczek();
    if(!el) return;
    el.classList.add("is-widoczny");
    document.body.style.overflow="hidden";
    var b=document.getElementById("onbStart");
    if(b) b.focus();
  }
  function zamknijSamouczek(){
    if(!onb || !onb.classList.contains("is-widoczny")) return;
    onb.classList.remove("is-widoczny");
    document.body.style.overflow="";
    zapamietajSamouczek();
  }

  var ponow=document.getElementById("jakPonow");
  if(ponow && SAM){
    ponow.hidden=false;   // bez JS przycisk nie mialby czego otworzyc
    ponow.addEventListener("click", pokazSamouczek);
  }
  /* Chwila zwloki, zeby strona zdazyla sie namalowac. Okienko wpadajace pol
     sekundy po wejsciu czyta sie jak reklama, a nie jak pomoc. */
  if(SAM && SAM.auto && !widzialSamouczek() && window.matchMedia("(max-width:1040px)").matches){
    setTimeout(pokazSamouczek, 700);
  }

  rysuj();
})();
